import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext.jsx';

export default function RequireAuth({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center text-sm text-slate-500">
        Loading…
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  // T071 — Users who haven't been through the first-login wizard get
  // bounced to /onboarding. The wizard's last step calls
  // POST /api/auth/complete-onboarding which sets user.onboardedAt and
  // releases this gate. The /onboarding route is itself protected by
  // this same RequireAuth, so we must explicitly let it through when
  // the user is mid-wizard.
  if (!user.onboardedAt && location.pathname !== '/onboarding') {
    return <Navigate to="/onboarding" replace />;
  }

  return children;
}
